// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OnboardingTemplate from "./OnboardingTemplate.bs.jsx";

function BiometricAuthn(props) {
  let onSkip = props.onSkip;
  let onSetupAuthn = props.onSetupAuthn;
  return <OnboardingTemplate.make
    loadingOverlay={props.loadingOverlay}
  >
    <h2>
      {"Přihlášení bez hesla"}
    </h2>
    <p>
      {`Tvoje zařízení umožňuje přihlásit se bez hesla.`}
    </p>
    {Stdlib_Option.mapOr(props.setupError, null, param => <p
      className={Styles.messageBar.variantDanger}
    >
      {"Nastavení se nezdařilo. Zkus to znovu nebo tento krok přeskoč."}
    </p>)}
    <button
      className={Styles.button.base}
      type={"button"}
      onClick={param => onSetupAuthn()}
    >
      {`Nastavit`}
    </button>
    <button
      className={Styles.link.base}
      type={"button"}
      onClick={param => onSkip()}
    >
      {`Přeskočit`}
    </button>
  </OnboardingTemplate.make>;
}

let make = BiometricAuthn;

export {
  make,
}
/* Styles Not a pure module */
